import { colors } from '@lmc/common/constants'
import type { HomeSource } from '@lmc/ts-common'
import {
  CarePlansModuleCard,
  DocumentsModuleCard,
  FamilyPlanModuleCard,
  IconType
} from '@lmc/ui-kit'
import type React from 'react'
import { connect } from 'react-redux'
import { PaywallTemplateWrapper } from '../../../../../components/generic/PaywallTemplateWrapper'

interface StateProps {
  source?: HomeSource
  testId?: string
}

const EMARPaywallComponent: React.FC<StateProps> = ({ source, testId }) => {
  const isSelfServe = source === 'Self-serve'

  return (
    <PaywallTemplateWrapper
      backgroundColor={colors.informationblue}
      title="Medication administration (eMAR)"
      subTitle="Organise medication rounds and minimise errors with our eMAR add-on. Track stock levels and detect discrepancies from one central place. Have complete control over your medication management."
      bodyText="Improve accountability and medication management."
      icon={IconType.EmarHexagon}
      videoUrl="https://www.youtube.com/embed/pC0o1dLoGg8"
      data-testid={testId ? `${testId}-emar-paywall` : 'emar-paywall'}
      articles={[
        {
          title: 'How do I get started with eMAR?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/4851779-get-started-with-the-emar-add-on',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How do I set up stock counting?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/5302857-how-do-i-set-up-stock-counting',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What can I do with the eMAR add-on?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/2749236-emar',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={
        isSelfServe ? <DocumentsModuleCard /> : <CarePlansModuleCard />
      }
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://www.logmycare.co.uk/features/care-delivery#emar"
      customLinkText="Read more"
    />
  )
}

const mapStateToProps = (state: any) => ({
  source: state.global?.home?.source
})

export const EMARPaywall = connect(mapStateToProps)(EMARPaywallComponent)
